export default {
  path: "unit",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "Unit Management",
      meta: {
        requiresAuth: true,
      },
      component: () => import("@/views/unit/createUnit.vue"),
    },
    {
      path: "unit-listing/:id",
      name: "Unit list",
      meta: {
        requiresAuth: true,
      },
      component: () => import("@/views/unit/unit.vue"),
    },
    {
      path: "updateUnitInfo/:id",
      name: "Update Unit Info",
      meta: {
        requiresAuth: true,
      },
      component: () => import("@/views/unit/updateUnitInfo.vue"),
    },
  ],
};
